




























































































import { Vue, Component, Prop } from "vue-property-decorator";
import { LaborExportClass } from "@/services/LaborExportClass";
import { getFileName } from "@/utils/files-helper";
import TextField from "@/components/form/CustomPage/textField.vue";
import { EducationProtocolExport as IEducationProtocolExport } from "@/api-v2/labor-protection/models/education-protocol-export";
import api from "@/getinfo-api";

@Component({
  components: { TextField }
})
export default class LaborExportDetailInfo extends Vue {
  @Prop() id!: string;
  info!: IEducationProtocolExport;
  isLoading: boolean = false;
  isCheckCourseInProgress: boolean = false;

  data() {
    return {
      info: undefined
    };
  }

  get fileName() {
    return getFileName(this.info.file);
  }

  async checkCourseVersion(id: string) {
    try {
      this.isCheckCourseInProgress = true;
      const response = await api.CourseApi.get(id);
      if (response.status === 200) {
        await this.$router.push({
          name: "courseView",
          params: { courseId: id }
        });
      } else {
        await this.$router.push({ name: "course", params: { id: id } });
      }
    } catch (e) {
      await this.$router.push({ name: "course", params: { id: id } });
    } finally {
      this.isCheckCourseInProgress = false;
    }
  }

  async getInfo() {
    try {
      this.isLoading = true;
      this.info = await LaborExportClass.getDetailInfo(this.id);
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getInfo();
  }
}
